import Player from "./Player";
export {PlayOnView} from "./PlayOnView";
export default Player;
